import { Modal as AntModal } from "antd";
import { Box, Typography, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function ShiftCreditLimitAndDueDate({
  visible,
  onClose,
  onReview,
  shifts,
  onBilling,
  amount,
}) {
  return (
    <AntModal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={true}
      maskClosable={false}
      keyboard={false}
      bodyStyle={{
        padding: "24px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* First Shift Card */}
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          p: 2,
          mb: 2,
          backgroundColor: "#fff",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
          <WarningAmberIcon sx={{ color: "#FF9800", mt: 0.3 }} />
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Job Posting Disabled
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#555", mb: 1.5, lineHeight: 1.5 }}
            >
              You currently have shifts from the past {shifts} that are pending
              approval.
            </Typography>
            <Typography variant="body2" sx={{ color: "#777", lineHeight: 1.5 }}>
              Please provide approval on shifts for that period to continue
              posting jobs.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ textAlign: "right", mt: 2 }}>
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "6px",
              backgroundColor: "#007bff",
              "&:hover": { backgroundColor: "#0069d9" },
            }}
            onClick={onReview}
          >
            Review Shifts
          </Button>
        </Box>
      </Box>

      {/* Second Credit Limit Card */}
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          p: 2,
          backgroundColor: "#fff",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
          <WarningAmberIcon sx={{ color: "#FF9800", mt: 0.3 }} />
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Job Posting Disabled
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#555", mb: 1.5, lineHeight: 1.5 }}
            >
              Your branch has reached its credit limit.
            </Typography>
            <Typography variant="body2" sx={{ color: "#777", lineHeight: 1.5 }}>
              Please contact our finance team at{" "}
              <a
                href="mailto:finance@jobizo.com"
                style={{ color: "#007bff", textDecoration: "none" }}
              >
                finance@jobizo.com
              </a>{" "}
              to clear outstanding dues.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Third Due Date Card */}
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          p: 2,
          mt: 2,
          backgroundColor: "#fff",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
          <WarningAmberIcon sx={{ color: "#FF9800", mt: 0.3 }} />
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Job Posting Disabled
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#555", mb: 1.5, lineHeight: 1.5 }}
            >
              Your payment due date has passed. Please clear the outstanding
              dues of {amount} to continue posting shifts
            </Typography>
          </Box>
        </Box>

        <Box sx={{ textAlign: "right", mt: 2 }}>
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "6px",
              backgroundColor: "#007bff",
              "&:hover": { backgroundColor: "#0069d9" },
            }}
            onClick={onBilling}
          >
            Pay Now
          </Button>
        </Box>
      </Box>
    </AntModal>
  );
}
